export type ObjArrayItem = {
  id: string | number;
  [key: string]: any,
};

export const strToNumberFormat = (str: string | number): string => {
  const sliceNumber = (a: string) => {
    let result = (+a).toString().split(".");
    return result[0].concat(".", !!result[1] ? result[1].length > 2 ? result[1].slice(0, 2) : result[1] : '00');
  }

  return Number(sliceNumber(`${str}`)).toLocaleString('ru', {
    maximumFractionDigits: 20,
    minimumFractionDigits: 2
  }).toString()
}

export const strToIntegerNumberFormat = (str: string | number): string => {
  let number = + str;
  return number.toLocaleString('ru', { maximumFractionDigits: 2 }).toString()
}

type OptionsType = {
  expires?: Date | string,
  path?: string,
  [key: string]: any,
}

export const setCookie = (name: string, value: any, options: OptionsType = {}): void => {
  options = {
    path: '/',
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export const setCookieObject = (name: string, value: any, options: OptionsType = {}): void => {
  options = {
    path: '/',
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + value;

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export const getCookie = (name: string): string => {
  const nameLenPlus = (name.length + 1);
  const cookie = document.cookie
    .split(';')
    .map(c => c.trim())
    .filter(cookie => {
      return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
    .map(cookie => {
      return decodeURIComponent(cookie.substring(nameLenPlus));
    })[0] || "null";

  return cookie
};

export const deleteCookie = (name: string) => {
  const date = new Date();
  date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
  document.cookie = name+"=; expires="+date.toUTCString()+"; path=/";
};

export const getAnid = (click_id: string, source_id: string, sub_id: string) => {
  if (!click_id && !source_id && !sub_id) {
    return '';
  }

  if (!click_id) {
    if (!source_id) {
      if (!sub_id) {
        return ''
      } else {
        return sub_id
      }
    } else {
      if (!sub_id) {
        return source_id
      } else {
        return `${source_id && `${source_id}`}${sub_id && `_${sub_id}`}`
      }
    }
  } else {
    return `${click_id}${source_id && `_${source_id}`}${sub_id && `_${sub_id}`}`
  }
};

export const numberToLocaleFormat = (str: string | number, locale: string, fractionDigits = 2): string => {
  const num = Number(str);

  if (isNaN(num) || !isFinite(num)) return String(str);

  if (Math.abs(num) < 1e-20) return '0';

  let fixedStr = num.toFixed(fractionDigits + 10);
  fixedStr = fixedStr.replace(/\.?0+$/, '');

  let [intPart, decPart = ''] = fixedStr.split('.');
  decPart = decPart.slice(0, fractionDigits);

  intPart = spaceDigits(intPart);

  const decimalSeparator = locale === 'ru' ? ',' : '.';

  return decPart ? `${intPart}${decimalSeparator}${decPart}` : intPart;
};

export const numberToLocaleFormatInteger = (str: string | number, locale: string, fractionDigits = 2): string => {
  const num = Number(str);

  if (isNaN(num) || !isFinite(num)) return String(str);

  if (Math.abs(num) < 1e-20) return '0';

  let fixedStr = num.toFixed(20);
  fixedStr = fixedStr.replace(/\.?0+$/, '');

  let [intPart, decPart = ''] = fixedStr.split('.');

  decPart = decPart.slice(0, fractionDigits);

  intPart = spaceDigits(intPart);

  const decimalSeparator = locale === 'ru' ? ',' : '.';

  return decPart ? `${intPart}${decimalSeparator}${decPart}` : intPart;
};

export const spaceDigits = (number:string | number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

const truncateDecimal = (num: number, digits: number): string => {
  const [intPart, decPart = ''] = num.toString().split('.');
  return decPart.length > 0
    ? intPart + '.' + decPart.slice(0, digits)
    : intPart;
};

export const getIds = (arr: ObjArrayItem[]): string[] | number[] => {
  return arr.reduce((acc: string[] | number[], el) => {
    //@ts-ignore
    acc.push(el.id);
    return acc;
  }, []);
}

export const normalizeNumber = (value: string | number): string => {
	const str = String(value).replace(',', '.');
	return str.replace(/\.?0+$/, '');
}

export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
